import { render, staticRenderFns } from "./IcoachSkillComment.vue?vue&type=template&id=b72951b4&"
import script from "./IcoachSkillComment.vue?vue&type=script&lang=ts&"
export * from "./IcoachSkillComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports